import { useEffect } from 'react';

const SITE_URL = 'https://carolmezher.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;
const JSON_LD_ID = 'seo-head-jsonld';

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [, key, val] = selector.match(/\[(.+?)="(.+?)"\]/) || [];
    if (key && val) el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const SeoHead = ({
  title,
  description,
  path = '/',
  image = DEFAULT_OG_IMAGE,
  ogType = 'profile',
  jsonLd,
}) => {
  const url = `${SITE_URL}${path}`;

  useEffect(() => {
    if (title) document.title = title;

    if (description) setMeta('meta[name="description"]', 'content', description);

    setLink('canonical', url);

    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[property="og:image"]', 'content', image);
    setMeta('meta[property="og:type"]', 'content', ogType);

    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:image"]', 'content', image);

    const existing = document.getElementById(JSON_LD_ID);
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = JSON_LD_ID;
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, url, image, ogType, jsonLd]);

  return null;
};

export default SeoHead;
